import { apiFetch } from './api';

/**
 * Get current user's profile
 */
export function getProfile() {
  return apiFetch('/api/admin/profile');
}

/**
 * Update current user's profile
 */
export function updateProfile(data) {
  return apiFetch('/api/admin/profile', {
    method: 'PUT',
    body: data
  });
}

/**
 * Change password
 */
export function changePassword(data) {
  return apiFetch('/api/admin/profile/change-password', {
    method: 'POST',
    body: data
  });
}


